import { connect } from "react-redux";
import { Navigate, useLocation } from "react-router";
import { routes } from "./routes";
import { EXCLUDED_ROLES_FROM_MEMBER_APP_REDIRECT } from "helpers/constants";

const PrivateRoute = ({ children, metaProps, user }) => {
  const location = useLocation()
  if (!user) {
    return (
      <Navigate to={`${routes.login.path}?from=${location.pathname}`} />
    )
  }
  if (!user.agreedToRules && !metaProps.isWelcome) {
    let path = routes.welcomePage.path
    if (location.pathname !== '/') {
      path = `${routes.welcomePage.path}?from=${location.pathname}`;
    }
    return (
      <Navigate to={path} />
    )
  }
  // Strict Login Check for Member Roles
  const isExcluded = user?.role?.name && EXCLUDED_ROLES_FROM_MEMBER_APP_REDIRECT.includes(user.role.name);

  if (user && !isExcluded) {
    const isFullyApproved = user.approveduser && user.applicationstatus === 'approved';
    if (!isFullyApproved && location.pathname !== routes.memberApplication.path && !metaProps.isWelcome) {
      return <Navigate to={routes.memberApplication.path} />
    }
  }
  if (user && !user.approveduser && metaProps.onlyApprovedUser && location.pathname !== routes.memberApplication.path) {
    return (
      <Navigate to={routes.restrictedPage.path} />
    )
  }
  if (user && metaProps.permissionKey && !['read', 'full'].includes(user?.role?.permissions[metaProps.permissionKey] || '')) {
    return (
      <Navigate to='/404' />
    )
  }
  if (user && metaProps.isAdminRoute && user?.role?.permissions?.admin !== 'full') {
    return <Navigate to="/404" />;
  }
  return <div>{children}</div>;
};

export default connect(({ auth }) => ({ user: auth.user }))(PrivateRoute);
